import React from 'react'
import ReactNumberFormat from 'react-number-format'
import { formats, NumberFormat } from '../config'

interface DisplayFormatedNumberProps {
  value: number
  className?: string
  format: NumberFormat
}

const DisplayFormatedNumber = ({ value, className, format }: DisplayFormatedNumberProps) => {
  const formatConfig = formats[format]

  return (
    <ReactNumberFormat
      value={value}
      displayType="text"
      thousandSeparator={true}
      className={className}
      {...formatConfig}
    />
  )
}

export default DisplayFormatedNumber
